import Form from "../../../../Components/Form"
import { useState, useEffect } from "react"
import { createOrUpdateTimeTracking } from "../../../../Model/TimeTracking"
import Text from "../../../../Components/Text"

const pad = (n) => String(n).padStart(2, "0")

const splitIso = (iso) => {
    if (!iso) return { date: "", time: "" }
    const withZ = iso.endsWith("Z") ? iso : `${iso}Z`
    const d = new Date(withZ)
    const date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    const time = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    return { date, time }
}

const buildIso = (date, time) => {
    if (!date || !time) return null
    const timeWithSeconds = time.length === 5 ? `${time}:00` : time
    const local = new Date(`${date}T${timeWithSeconds}`)
    return local.toISOString().split(".")[0] + "." + String(local.getMilliseconds()).padStart(3, "0")
}

export const EditTimeTrackingForm = ({ item, afterAction }) => {
    const [startDate, setStartDate] = useState("")
    const [startClock, setStartClock] = useState("")
    const [endDate, setEndDate] = useState("")
    const [endClock, setEndClock] = useState("")

    const [startTime, setStartTime] = useState(null)
    const [endTime, setEndTime] = useState(null)

    useEffect(() => {
        if (item) {
            const start = splitIso(item.startTime)
            const end = splitIso(item.endTime)
            setStartDate(start.date)
            setStartClock(start.time)
            setEndDate(end.date)
            setEndClock(end.time)
            setStartTime(item.startTime)
            setEndTime(item.endTime)
        }
    }, [])

    const handleStartDateChange = (value) => {
        setStartDate(value)
        setStartTime(buildIso(value, startClock))
    }

    const handleStartClockChange = (value) => {
        setStartClock(value)
        setStartTime(buildIso(startDate, value))
    }

    const handleEndDateChange = (value) => {
        setEndDate(value)
        setEndTime(buildIso(value, endClock))
    }

    const handleEndClockChange = (value) => {
        setEndClock(value)
        setEndTime(buildIso(endDate, value))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        item.startTime = startTime
        item.endTime = endTime
        await createOrUpdateTimeTracking(item)
        afterAction()
    }

    return (
        <Form onSubmitAction={handleSubmit} submitButtonText={"Stempelzeit Updaten"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}> {`Stempelzeit von ${item.user.firstName}`}</Text>

            <div className="flex flex-col gap-3 p-3">
                <div className="flex flex-col gap-1">
                    <Text type="itemtext">Startzeit</Text>
                    <div className="flex gap-3">
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => handleStartDateChange(e.target.value)}
                            className="border rounded px-2 py-1"
                        />
                        <input
                            type="time"
                            step="1"
                            value={startClock}
                            onChange={(e) => handleStartClockChange(e.target.value)}
                            className="border rounded px-2 py-1"
                        />
                    </div>
                </div>

                <div className="flex flex-col gap-1">
                    <Text type="itemtext">Endzeit</Text>
                    <div className="flex gap-3">
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => handleEndDateChange(e.target.value)}
                            className="border rounded px-2 py-1"
                        />
                        <input
                            type="time"
                            step="1"
                            value={endClock}
                            onChange={(e) => handleEndClockChange(e.target.value)}
                            className="border rounded px-2 py-1"
                        />
                    </div>
                </div>
            </div>
        </Form>
    )
}